import { gsap } from 'gsap';

export function useTransitionAnimations() {
  const animations: gsap.core.Tween[] = [];

  const onBeforeEnter = (el: Element) => {
    gsap.set(el, {
      opacity: 0,
      y: 20
    });
  };

  const onEnter = (el: Element, done: () => void) => {
    const animation = gsap.to(el, {
      opacity: 1,
      y: 0,
      duration: 0.3,
      ease: "power2.out",
      onComplete: done
    });
    animations.push(animation);
  };

const onLeave = (el: Element, done: () => void) => {
  // Skip if this element is already being removed via moderateMedia
  if (el.classList.contains('is-leaving')) {
    return done();
  }

  // Apply absolute positioning to prevent layout shift
  gsap.set(el, {
    position: 'absolute',
    width: `${el.clientWidth}px`,
    height: `${el.clientHeight}px`,
    margin: 0,
    pointerEvents: 'none'
  });

  // Animate out
  const animation = gsap.to(el, {
    opacity: 0,
    scale: 0.95,
    duration: 0.25,
    ease: "power2.in",
    onComplete: () => {
      gsap.set(el, { clearProps: 'all' });
      done();
    }
  });

  animations.push(animation);
};

  const cleanupAnimations = () => {
    animations.forEach(anim => anim.kill());
    animations.length = 0;
  };

  return { onBeforeEnter, onEnter, onLeave, cleanupAnimations };
}
